"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var TreeTable_1 = __importDefault(require("../../tree/tree-table/TreeTable"));
var FlexTabContainer_1 = __importDefault(require("./components/FlexTabContainer"));
var TceTable_1 = __importDefault(require("./TceTable"));
var utils_1 = require("./utils");
var TabPane = FlexTabContainer_1.default.TabPane;
function TabTceTable(props) {
    var style = props.style, configuration = props.configuration, restProps = __rest(props, ["style", "configuration"]);
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var _a = (0, react_1.useState)(true), currentClass = _a[0], setCurrentClass = _a[1];
    (0, react_1.useEffect)(function () {
        (0, utils_1.windowAddEventListener)(setCurrentClass);
    }, []);
    function FlexAccordion(props) {
        var configuration = props.configuration, style = props.style;
        var _a = (0, react_1.useState)(1), saveKey = _a[0], setSaveKey = _a[1];
        var childrenNodes = {};
        var chilen = configuration.length;
        var getHeightVal = (0, react_1.useRef)({});
        (0, react_1.useEffect)(function () {
            setTimeout(function () {
                if (getHeightVal) {
                    childrenNodes = getHeightVal.current.childNodes;
                    // todo optimize
                    // 12 初始状态下少12 offsetHeight
                    // 24 距离底部距离
                    for (var i = 0; i < childrenNodes.length; i++) {
                        if (i == 0) {
                            getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = 'auto';
                        }
                        else {
                            getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = '0';
                        }
                    }
                }
            }, 1000);
        }, []);
        var checkTabsStatus = function (key) {
            var _childrenNodes = getHeightVal;
            var _loop_1 = function (i) {
                // 查询到指定要获取高度
                var transformClass = _childrenNodes.current.childNodes[i].childNodes[0];
                if (i == Number(key) - 1) {
                    if (transformClass.className.indexOf("".concat(classPrefix, "__tabTceTable-children-mobile-item-leave")) > -1) {
                        setTimeout(function () {
                            // 24 距离底部距离
                            transformClass.lastChild.style.height = 'auto';
                        });
                        transformClass.className = "".concat(classPrefix, "__tabTceTable-children-mobile-item");
                    }
                    else {
                        transformClass.lastChild.style.height = '0';
                        transformClass.className = "".concat(classPrefix, "__tabTceTable-children-mobile-item-leave");
                    }
                }
                else {
                    transformClass.lastChild.style.height = '0';
                    transformClass.className = "".concat(classPrefix, "__tabTceTable-children-mobile-item-leave");
                }
            };
            // todo optimize
            for (var i = 0; i < _childrenNodes.current.childNodes.length; i++) {
                _loop_1(i);
            }
        };
        return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__tabTceTable-children-mobile"), style: typeof style === 'object' ? style : {} },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { ref: getHeightVal }, configuration.map(function (item, i) {
                    var _a;
                    var _b = item, title = _b.title, modTitle = _b.modTitle, key = _b.key;
                    return (react_1.default.createElement("div", { key: i },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)((_a = {},
                                _a["".concat(classPrefix, "__tabTceTable-children-mobile-item")] = i === 0,
                                _a["".concat(classPrefix, "__tabTceTable-children-mobile-item-leave")] = i !== 0,
                                _a)), style: chilen === 1 ? { background: 'none' } : {} },
                            react_1.default.createElement("div", { className: 'mobile-item-title', role: "button", "aria-expanded": "false", style: chilen === 1 ? { display: 'none' } : {}, onClick: function () {
                                    checkTabsStatus(key);
                                    if (key === saveKey) {
                                        setSaveKey(0);
                                    }
                                    else {
                                        setSaveKey(key);
                                    }
                                } },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("div", { className: 'mobile-item-title-h4' }, title),
                                    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: 'mobile-item-title-icon', fill: "#000000" },
                                        react_1.default.createElement("path", { transform: "rotate(-180 12.25 12.25)", d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z", fillRule: "evenodd" })))),
                            react_1.default.createElement("div", { className: 'mobile-item-container' },
                                react_1.default.createElement("div", { className: "".concat(classPrefix, "__tabTceTable-pane") },
                                    react_1.default.createElement("div", { className: "".concat(classPrefix, "__tabTceTable-pane-title") }, modTitle),
                                    key === 1 && react_1.default.createElement(TreeTable_1.default, __assign({}, restProps)),
                                    key === 2 && react_1.default.createElement(TceTable_1.default, __assign({}, restProps)))))));
                })))));
    }
    return (react_1.default.createElement("div", __assign({}, restProps, { className: "".concat(classPrefix, "__tabTceTable"), style: typeof style === 'object' ? style : {} }),
        react_1.default.createElement("div", { className: "".concat(classPrefix, "__tabTceTable-children") }, currentClass ? (react_1.default.createElement("div", null,
            react_1.default.createElement(FlexTabContainer_1.default, __assign({}, restProps), configuration
                ? configuration.map(function (item, i) {
                    var _a;
                    var title = item.title, modTitle = item.modTitle, key = item.key;
                    return (react_1.default.createElement(TabPane, { key: i, tabIndex: key, title: title },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "__tabTceTable-children-pane"), (_a = {},
                                _a["".concat(classPrefix, "__tabTceTable-children-pane-active")] = key !== 1,
                                _a)), key: i },
                            key === 1 && (react_1.default.createElement("div", { className: "".concat(classPrefix, "__tabTceTable-pane") },
                                react_1.default.createElement("div", { className: "".concat(classPrefix, "__tabTceTable-pane-title") }, modTitle),
                                react_1.default.createElement(TreeTable_1.default, __assign({}, restProps)))),
                            key === 2 && (react_1.default.createElement("div", { className: "".concat(classPrefix, "__tabTceTable-pane") },
                                react_1.default.createElement("div", { className: "".concat(classPrefix, "__tabTceTable-pane-title") }, modTitle),
                                react_1.default.createElement(TceTable_1.default, __assign({}, restProps)))))));
                })
                : null))) : (react_1.default.createElement(FlexAccordion, { style: style, configuration: configuration })))));
}
exports.default = TabTceTable;
//# sourceMappingURL=TabTceTable.js.map